export const VitaminBoostDailyFixture = {
  id: 3,
  title: 'Vitamin Lenses',
  handle: 'vitamin-lenses',
  description:
    'Help your eyes relax with our ultra-comfortable vitamin lenses.',
  productVariants: [
    {
      id: 101,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-0-50',
      label: null,
      description: null,
      assets: [
        {
          asset: {
            id: 2,
            path: '/images/products/vitamin-lens/2-Vitamin.png',
          },
        },
      ],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.50',
            value: '-0.50',
            id: 1,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 401,
          region: 'US',
          sku: 'WALVIT-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 402,
          region: 'UK',
          sku: 'WALVIT-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 403,
          region: 'SE',
          sku: 'WALVIT-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 404,
          region: 'EU',
          sku: 'WALVIT-0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 102,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -0.75',
            value: '-0.75',
            id: 2,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 405,
          region: 'US',
          sku: 'WALVIT-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 406,
          region: 'UK',
          sku: 'WALVIT-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 407,
          region: 'SE',
          sku: 'WALVIT-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 408,
          region: 'EU',
          sku: 'WALVIT-0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 103,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.00',
            value: '-1.00',
            id: 3,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 409,
          region: 'US',
          sku: 'WALVIT-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 410,
          region: 'UK',
          sku: 'WALVIT-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 411,
          region: 'SE',
          sku: 'WALVIT-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 412,
          region: 'EU',
          sku: 'WALVIT-1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 104,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.25',
            value: '-1.25',
            id: 4,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 413,
          region: 'US',
          sku: 'WALVIT-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 414,
          region: 'UK',
          sku: 'WALVIT-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 415,
          region: 'SE',
          sku: 'WALVIT-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 416,
          region: 'EU',
          sku: 'WALVIT-1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 105,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.50',
            value: '-1.50',
            id: 5,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 417,
          region: 'US',
          sku: 'WALVIT-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 418,
          region: 'UK',
          sku: 'WALVIT-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 419,
          region: 'SE',
          sku: 'WALVIT-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 420,
          region: 'EU',
          sku: 'WALVIT-1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 106,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -1.75',
            value: '-1.75',
            id: 6,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 421,
          region: 'US',
          sku: 'WALVIT-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 422,
          region: 'UK',
          sku: 'WALVIT-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 423,
          region: 'SE',
          sku: 'WALVIT-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 424,
          region: 'EU',
          sku: 'WALVIT-1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 107,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.00',
            value: '-2.00',
            id: 7,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 425,
          region: 'US',
          sku: 'WALVIT-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 426,
          region: 'UK',
          sku: 'WALVIT-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 427,
          region: 'SE',
          sku: 'WALVIT-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 428,
          region: 'EU',
          sku: 'WALVIT-2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 108,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.25',
            value: '-2.25',
            id: 8,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 429,
          region: 'US',
          sku: 'WALVIT-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 430,
          region: 'UK',
          sku: 'WALVIT-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 431,
          region: 'SE',
          sku: 'WALVIT-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 432,
          region: 'EU',
          sku: 'WALVIT-2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 109,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.50',
            value: '-2.50',
            id: 9,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 433,
          region: 'US',
          sku: 'WALVIT-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 434,
          region: 'UK',
          sku: 'WALVIT-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 435,
          region: 'SE',
          sku: 'WALVIT-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 436,
          region: 'EU',
          sku: 'WALVIT-2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 110,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -2.75',
            value: '-2.75',
            id: 10,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 437,
          region: 'US',
          sku: 'WALVIT-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 438,
          region: 'UK',
          sku: 'WALVIT-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 439,
          region: 'SE',
          sku: 'WALVIT-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 440,
          region: 'EU',
          sku: 'WALVIT-2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 111,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.00',
            value: '-3.00',
            id: 11,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 441,
          region: 'US',
          sku: 'WALVIT-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 442,
          region: 'UK',
          sku: 'WALVIT-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 443,
          region: 'SE',
          sku: 'WALVIT-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 444,
          region: 'EU',
          sku: 'WALVIT-3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 112,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.25',
            value: '-3.25',
            id: 12,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 445,
          region: 'US',
          sku: 'WALVIT-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 446,
          region: 'UK',
          sku: 'WALVIT-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 447,
          region: 'SE',
          sku: 'WALVIT-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 448,
          region: 'EU',
          sku: 'WALVIT-3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 113,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.50',
            value: '-3.50',
            id: 13,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 449,
          region: 'US',
          sku: 'WALVIT-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 450,
          region: 'UK',
          sku: 'WALVIT-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 451,
          region: 'SE',
          sku: 'WALVIT-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 452,
          region: 'EU',
          sku: 'WALVIT-3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 114,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -3.75',
            value: '-3.75',
            id: 14,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 453,
          region: 'US',
          sku: 'WALVIT-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 454,
          region: 'UK',
          sku: 'WALVIT-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 455,
          region: 'SE',
          sku: 'WALVIT-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 456,
          region: 'EU',
          sku: 'WALVIT-3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 115,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.00',
            value: '-4.00',
            id: 15,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 457,
          region: 'US',
          sku: 'WALVIT-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 458,
          region: 'UK',
          sku: 'WALVIT-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 459,
          region: 'SE',
          sku: 'WALVIT-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 460,
          region: 'EU',
          sku: 'WALVIT-4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 116,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-4-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.25',
            value: '-4.25',
            id: 16,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 461,
          region: 'US',
          sku: 'WALVIT-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 462,
          region: 'UK',
          sku: 'WALVIT-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 463,
          region: 'SE',
          sku: 'WALVIT-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 464,
          region: 'EU',
          sku: 'WALVIT-4.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 117,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-4-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.50',
            value: '-4.50',
            id: 17,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 465,
          region: 'US',
          sku: 'WALVIT-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 466,
          region: 'UK',
          sku: 'WALVIT-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 467,
          region: 'SE',
          sku: 'WALVIT-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 468,
          region: 'EU',
          sku: 'WALVIT-4.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 118,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-4-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -4.75',
            value: '-4.75',
            id: 18,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 469,
          region: 'US',
          sku: 'WALVIT-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 470,
          region: 'UK',
          sku: 'WALVIT-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 471,
          region: 'SE',
          sku: 'WALVIT-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 472,
          region: 'EU',
          sku: 'WALVIT-4.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 119,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-5-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.00',
            value: '-5.00',
            id: 19,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 473,
          region: 'US',
          sku: 'WALVIT-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 474,
          region: 'UK',
          sku: 'WALVIT-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 475,
          region: 'SE',
          sku: 'WALVIT-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 476,
          region: 'EU',
          sku: 'WALVIT-5.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 120,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-5-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.25',
            value: '-5.25',
            id: 20,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 477,
          region: 'US',
          sku: 'WALVIT-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 478,
          region: 'UK',
          sku: 'WALVIT-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 479,
          region: 'SE',
          sku: 'WALVIT-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 480,
          region: 'EU',
          sku: 'WALVIT-5.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 121,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-5-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.50',
            value: '-5.50',
            id: 21,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 481,
          region: 'US',
          sku: 'WALVIT-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 482,
          region: 'UK',
          sku: 'WALVIT-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 483,
          region: 'SE',
          sku: 'WALVIT-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 484,
          region: 'EU',
          sku: 'WALVIT-5.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 122,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-5-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -5.75',
            value: '-5.75',
            id: 22,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 485,
          region: 'US',
          sku: 'WALVIT-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 486,
          region: 'UK',
          sku: 'WALVIT-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 487,
          region: 'SE',
          sku: 'WALVIT-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 488,
          region: 'EU',
          sku: 'WALVIT-5.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 123,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-6-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.00',
            value: '-6.00',
            id: 23,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 489,
          region: 'US',
          sku: 'WALVIT-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 490,
          region: 'UK',
          sku: 'WALVIT-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 491,
          region: 'SE',
          sku: 'WALVIT-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 492,
          region: 'EU',
          sku: 'WALVIT-6.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 124,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-6-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -6.50',
            value: '-6.50',
            id: 24,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 493,
          region: 'US',
          sku: 'WALVIT-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 494,
          region: 'UK',
          sku: 'WALVIT-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 495,
          region: 'SE',
          sku: 'WALVIT-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 496,
          region: 'EU',
          sku: 'WALVIT-6.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 125,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-7-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.00',
            value: '-7.00',
            id: 25,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 497,
          region: 'US',
          sku: 'WALVIT-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 498,
          region: 'UK',
          sku: 'WALVIT-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 499,
          region: 'SE',
          sku: 'WALVIT-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 500,
          region: 'EU',
          sku: 'WALVIT-7.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 126,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-7-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -7.50',
            value: '-7.50',
            id: 26,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 501,
          region: 'US',
          sku: 'WALVIT-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 502,
          region: 'UK',
          sku: 'WALVIT-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 503,
          region: 'SE',
          sku: 'WALVIT-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 504,
          region: 'EU',
          sku: 'WALVIT-7.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 127,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-8-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.00',
            value: '-8.00',
            id: 27,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 505,
          region: 'US',
          sku: 'WALVIT-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 506,
          region: 'UK',
          sku: 'WALVIT-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 507,
          region: 'SE',
          sku: 'WALVIT-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 508,
          region: 'EU',
          sku: 'WALVIT-8.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 128,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-8-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -8.50',
            value: '-8.50',
            id: 28,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 509,
          region: 'US',
          sku: 'WALVIT-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 510,
          region: 'UK',
          sku: 'WALVIT-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 511,
          region: 'SE',
          sku: 'WALVIT-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 512,
          region: 'EU',
          sku: 'WALVIT-8.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 129,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-9-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.00',
            value: '-9.00',
            id: 29,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 513,
          region: 'US',
          sku: 'WALVIT-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 514,
          region: 'UK',
          sku: 'WALVIT-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 515,
          region: 'SE',
          sku: 'WALVIT-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 516,
          region: 'EU',
          sku: 'WALVIT-9.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 130,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-9-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -9.50',
            value: '-9.50',
            id: 30,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 517,
          region: 'US',
          sku: 'WALVIT-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 518,
          region: 'UK',
          sku: 'WALVIT-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 519,
          region: 'SE',
          sku: 'WALVIT-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 520,
          region: 'EU',
          sku: 'WALVIT-9.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 131,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-10-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.00',
            value: '-10.00',
            id: 31,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 521,
          region: 'US',
          sku: 'WALVIT-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 522,
          region: 'UK',
          sku: 'WALVIT-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 523,
          region: 'SE',
          sku: 'WALVIT-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 524,
          region: 'EU',
          sku: 'WALVIT-10.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 132,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-10-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -10.50',
            value: '-10.50',
            id: 32,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 525,
          region: 'US',
          sku: 'WALVIT-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 526,
          region: 'UK',
          sku: 'WALVIT-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 527,
          region: 'SE',
          sku: 'WALVIT-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 528,
          region: 'EU',
          sku: 'WALVIT-10.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 133,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-11-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.00',
            value: '-11.00',
            id: 33,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 529,
          region: 'US',
          sku: 'WALVIT-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 530,
          region: 'UK',
          sku: 'WALVIT-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 531,
          region: 'SE',
          sku: 'WALVIT-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 532,
          region: 'EU',
          sku: 'WALVIT-11.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 134,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-11-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -11.50',
            value: '-11.50',
            id: 34,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 533,
          region: 'US',
          sku: 'WALVIT-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 534,
          region: 'UK',
          sku: 'WALVIT-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 535,
          region: 'SE',
          sku: 'WALVIT-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 536,
          region: 'EU',
          sku: 'WALVIT-11.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 135,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-negative-12-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power -12.00',
            value: '-12.00',
            id: 35,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 537,
          region: 'US',
          sku: 'WALVIT-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 538,
          region: 'UK',
          sku: 'WALVIT-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 539,
          region: 'SE',
          sku: 'WALVIT-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 540,
          region: 'EU',
          sku: 'WALVIT-12.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 136,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-0-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.50',
            value: '+0.50',
            id: 36,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 541,
          region: 'US',
          sku: 'WALVIT+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 542,
          region: 'UK',
          sku: 'WALVIT+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 543,
          region: 'SE',
          sku: 'WALVIT+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 544,
          region: 'EU',
          sku: 'WALVIT+0.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 137,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-0-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +0.75',
            value: '+0.75',
            id: 37,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 545,
          region: 'US',
          sku: 'WALVIT+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 546,
          region: 'UK',
          sku: 'WALVIT+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 547,
          region: 'SE',
          sku: 'WALVIT+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 548,
          region: 'EU',
          sku: 'WALVIT+0.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 138,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-1-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.00',
            value: '+1.00',
            id: 38,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 549,
          region: 'US',
          sku: 'WALVIT+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 550,
          region: 'UK',
          sku: 'WALVIT+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 551,
          region: 'SE',
          sku: 'WALVIT+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 552,
          region: 'EU',
          sku: 'WALVIT+1.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 139,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-1-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.25',
            value: '+1.25',
            id: 39,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 553,
          region: 'US',
          sku: 'WALVIT+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 554,
          region: 'UK',
          sku: 'WALVIT+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 555,
          region: 'SE',
          sku: 'WALVIT+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 556,
          region: 'EU',
          sku: 'WALVIT+1.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 140,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-1-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.50',
            value: '+1.50',
            id: 40,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 557,
          region: 'US',
          sku: 'WALVIT+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 558,
          region: 'UK',
          sku: 'WALVIT+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 559,
          region: 'SE',
          sku: 'WALVIT+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 560,
          region: 'EU',
          sku: 'WALVIT+1.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 141,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-1-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +1.75',
            value: '+1.75',
            id: 41,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 561,
          region: 'US',
          sku: 'WALVIT+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 562,
          region: 'UK',
          sku: 'WALVIT+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 563,
          region: 'SE',
          sku: 'WALVIT+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 564,
          region: 'EU',
          sku: 'WALVIT+1.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 142,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-2-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.00',
            value: '+2.00',
            id: 42,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 565,
          region: 'US',
          sku: 'WALVIT+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 566,
          region: 'UK',
          sku: 'WALVIT+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 567,
          region: 'SE',
          sku: 'WALVIT+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 568,
          region: 'EU',
          sku: 'WALVIT+2.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 143,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-2-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.25',
            value: '+2.25',
            id: 43,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 569,
          region: 'US',
          sku: 'WALVIT+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 570,
          region: 'UK',
          sku: 'WALVIT+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 571,
          region: 'SE',
          sku: 'WALVIT+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 572,
          region: 'EU',
          sku: 'WALVIT+2.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 144,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-2-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.50',
            value: '+2.50',
            id: 44,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 573,
          region: 'US',
          sku: 'WALVIT+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 574,
          region: 'UK',
          sku: 'WALVIT+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 575,
          region: 'SE',
          sku: 'WALVIT+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 576,
          region: 'EU',
          sku: 'WALVIT+2.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 145,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-2-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +2.75',
            value: '+2.75',
            id: 45,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 577,
          region: 'US',
          sku: 'WALVIT+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 578,
          region: 'UK',
          sku: 'WALVIT+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 579,
          region: 'SE',
          sku: 'WALVIT+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 580,
          region: 'EU',
          sku: 'WALVIT+2.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 146,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-3-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.00',
            value: '+3.00',
            id: 46,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 581,
          region: 'US',
          sku: 'WALVIT+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 582,
          region: 'UK',
          sku: 'WALVIT+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 583,
          region: 'SE',
          sku: 'WALVIT+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 584,
          region: 'EU',
          sku: 'WALVIT+3.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 147,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-3-25',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.25',
            value: '+3.25',
            id: 47,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 585,
          region: 'US',
          sku: 'WALVIT+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 586,
          region: 'UK',
          sku: 'WALVIT+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 587,
          region: 'SE',
          sku: 'WALVIT+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 588,
          region: 'EU',
          sku: 'WALVIT+3.25',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 148,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-3-50',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.50',
            value: '+3.50',
            id: 48,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 589,
          region: 'US',
          sku: 'WALVIT+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 590,
          region: 'UK',
          sku: 'WALVIT+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 591,
          region: 'SE',
          sku: 'WALVIT+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 592,
          region: 'EU',
          sku: 'WALVIT+3.50',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 149,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-3-85',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +3.75',
            value: '+3.75',
            id: 49,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 593,
          region: 'US',
          sku: 'WALVIT+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 594,
          region: 'UK',
          sku: 'WALVIT+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 595,
          region: 'SE',
          sku: 'WALVIT+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 596,
          region: 'EU',
          sku: 'WALVIT+3.85',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
    {
      id: 150,
      title: 'Vitamin Lenses',
      handle: 'vitamin-lenses-positive-4-00',
      label: null,
      description: null,
      assets: [],
      attributes: [
        {
          attribute: {
            title: 'Eye Power +4.00',
            value: '+4.00',
            id: 50,
          },
        },
        {
          attribute: {
            title: '30 Lenses',
            value: '30',
            id: 52,
          },
        },
      ],
      locales: [
        {
          id: 597,
          region: 'US',
          sku: 'WALVIT+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 0,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 0,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 598,
          region: 'UK',
          sku: 'WALVIT+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 9100,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 17000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 33700,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 599,
          region: 'SE',
          sku: 'WALVIT+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 4800,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 10800,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 20200,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 39800,
            },
          ],
          shippingOptions: [],
        },
        {
          id: 600,
          region: 'EU',
          sku: 'WALVIT+4.00',
          pricing: [
            {
              quantity: 1,
              basePrice: 0,
              actualPrice: 49000,
            },
            {
              quantity: 3,
              basePrice: 0,
              actualPrice: 110000,
            },
            {
              quantity: 6,
              basePrice: 0,
              actualPrice: 209000,
            },
            {
              quantity: 12,
              basePrice: 0,
              actualPrice: 409000,
            },
          ],
          shippingOptions: [],
        },
      ],
      highlights: [],
    },
  ],
};
